import styled, { css, DefaultTheme } from 'styled-components';
import { Overlay } from '@mtnkente/paragon-overlays/overlay';

export const LoadingOverlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 500;

  width: 100%;
  height: 100vh;
  background: ${({ theme }): string => theme.colors['page-bg-vibrant-bg']};
`;

export const LoadingFrame = styled.div`
  ${({ theme: { floats } }): DefaultTheme => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${floats['app-container-vertical-margin-small']};
      align-self: stretch;
      justify-content: center;
      justify-items: center;
    `;
  }}
`;

export const ModalOverlay = styled(Overlay)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const DialogContainer = styled.div`
  max-width: 95%;
`;
